import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import App from './App';
import { chakraSystem } from './theme';
import './styles/globals.css';
import 'react-phone-number-input/style.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ChakraProvider value={chakraSystem}>
      <HashRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </HashRouter>
    </ChakraProvider>
  </StrictMode>
);

// Once React has painted, hide the native Capacitor splash and fade out the
// HTML splash overlay (logo + continuous-circle spinner) defined in index.html.
function dismissSplash() {
  if (Capacitor.isNativePlatform()) {
    SplashScreen.hide().catch(() => {});
  }
  const overlay = document.getElementById('splash-overlay');
  if (!overlay) return;
  overlay.classList.add('splash-hidden');
  overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
}

// Double rAF ensures the first app frame is painted before we reveal it.
requestAnimationFrame(() => requestAnimationFrame(dismissSplash));
